import React from 'react';
import { useResults } from 'contexts/results';
import { PerkWaveStats } from 'utils/simulate';
import { useMaxWave } from 'contexts/gameState';

const WaveStatsResult: React.FC<{
  waveStats: PerkWaveStats;
  label: string;
  count: number;
}> = ({ waveStats, label, count }) => (
  <tr>
    <td className='label'>{label}:</td>
    <td className='value'>
      Avg Wave {(waveStats.wave / (waveStats.has || 1)).toFixed(2)}{' '}
    </td>
    <td className='percent'>
      ({waveStats.has} times,{' '}
      {((waveStats.has * 100) / (count || 1)).toFixed(2)}%)
    </td>
  </tr>
);

const Averages: React.FC<{}> = () => {
  const results = useResults();
  const maxWave = useMaxWave();
  return (
    <div id='averages'>
      <div className='title'>
        All results are shown as mean values, averaged among waves that manage
        to achieve the perk(s), with the count/percent of waves that did get it
        alongside.
      </div>
      <table cellSpacing={0}>
        <tbody>
          <tr>
            <td className='label'>Max wave:</td>
            <td className='value' colSpan={2}>
              {maxWave}
            </td>
          </tr>
          <tr>
            <td className='label'>Simulations:</td>
            <td className='value' colSpan={2}>
              {results.count.toFixed(0)}
            </td>
          </tr>
          <tr>
            <td className='label'>Perk count:</td>
            <td className='value' colSpan={2}>
              {results.stats.finalStats.perkCount.toFixed(2)}
            </td>
          </tr>
          <tr>
            <td className='label'>Average standard coin bonus perks:</td>
            <td className='value' colSpan={2}>
              {results.stats.finalStats.basicCoinBonuses.toFixed(2)}
            </td>
          </tr>
          <tr>
            <td className='label'>Average max hp perks:</td>
            <td className='value' colSpan={2}>
              {results.stats.finalStats.hpBonuses.toFixed(2)}
            </td>
          </tr>
          <tr>
            <td className='label'>Average defense percent perks:</td>
            <td className='value' colSpan={2}>
              {results.stats.finalStats.defenseBonuses.toFixed(2)}
            </td>
          </tr>
          <tr>
            <td className='label'>Average extra orb perks:</td>
            <td className='value' colSpan={2}>
              {results.stats.finalStats.extraOrbs.toFixed(2)}
            </td>
          </tr>
          <tr>
            <td className='label'>Average Final Multiplier:</td>
            <td className='value' colSpan={2}>
              {results.stats.finalStats.perkMultiplier.toFixed(2)}
            </td>
          </tr>
          <WaveStatsResult
            waveStats={results.stats.perkWaveStats.goldenTowerWave}
            label='1.5x Golden Tower perk'
            count={results.count}
          />
          <WaveStatsResult
            waveStats={results.stats.perkWaveStats.tradeoffCoinWave}
            label='Tradeoff coin perk'
            count={results.count}
          />
          <WaveStatsResult
            waveStats={results.stats.perkWaveStats.coinBonusesWave}
            label='5x Standard Coin perks'
            count={results.count}
          />
          <WaveStatsResult
            waveStats={results.stats.perkWaveStats.allCoinBonuses}
            label='All coin economy perks'
            count={results.count}
          />
          <WaveStatsResult
            waveStats={results.stats.perkWaveStats.gameSpeedWave}
            label='Game Speed perk'
            count={results.count}
          />
          <WaveStatsResult
            waveStats={results.stats.perkWaveStats.damageDamageWave}
            label='Damage/Damage tradeoff perk'
            count={results.count}
          />
          <WaveStatsResult
            waveStats={results.stats.perkWaveStats.allNeededPerks}
            label='All needed perks'
            count={results.count}
          />
          <WaveStatsResult
            waveStats={results.stats.perkWaveStats.firstPerkReduction}
            label='First perk reduction'
            count={results.count}
          />
          <WaveStatsResult
            waveStats={results.stats.perkWaveStats.secondPerkReduction}
            label='Second perk reduction'
            count={results.count}
          />
          <WaveStatsResult
            waveStats={results.stats.perkWaveStats.thirdPerkReduction}
            label='Third perk reduction'
            count={results.count}
          />
          <WaveStatsResult
            waveStats={results.stats.perkWaveStats.noMoreOptions}
            label='No more perks'
            count={results.count}
          />
        </tbody>
      </table>
    </div>
  );
};

export default Averages;
